<template>
<div class="block-brand-management-wrap">
  <div class="block-brand-header flex-row">
    <div class="block-label">品牌信息</div>
    <auth-button
      opt="add"
      @click.native="showDialog(1)"
      :loading="machinesLoading"
      class="block-btn"
      label="新建"></auth-button>
  </div>
  <div class="block-main">
    <div class="block-list flex-row">
      <div class="block-item flex-column" v-for="(item,index) in list" :key="index">
        <i class="el-icon-delete" @click="deleteBrand(item)"></i>
        <div class="block-top flex-row" @click="showDialog(2,item)">
          <img :src="item.brandLogoUrl" alt="" class="logo">
          <div class="block-right flex-column">
            <div class="block-title">{{item.brandName}}</div>
            <p class="block-id">品牌编码：{{item.id}}</p>
            <p class="block-num">门店数量：{{item.shopCount}}</p>
          </div>
        </div>
        <p class="block-desc">品牌介绍：{{item.brandIntroduction}}</p>
        <div class="block-bottom flex-row">
          <el-button type="primary" class="block-btn" @click="toShopList(item)">门店管理</el-button>
          <el-switch
            v-model="item.status"
            class="block-swtich"
            active-color="#13ce66"
            @change="modifyBrand(item)"
            inactive-color="#ccc">
          </el-switch>
        </div>
      </div>
    </div>
  </div>
  <add-brand v-model="addShow" @hanlderClose="addShow = false" v-if="addShow" :type="type" :rowInfo="rowInfo" @hanlderSuccessBrand="getBrandList"/>
</div>
</template>
<script>
import addBrand from './add-brand.vue'
import { getBrandList, deleteBrand, modifyBrand } from '@/api/merchant-info'
export default {
  components: {
    addBrand
  },
  data () {
    return {
      list: [],
      addShow: false,
      type: 1,
      rowInfo: {},
      loading: '',
      userInfo: {}
    }
  },
  created () {
    this.getBrandList()
    this.userInfo = localStorage.getItem('ZZGAgentUser') ? JSON.parse(localStorage.getItem('ZZGAgentUser')) : {}
  },
  methods: {
    toShopList (item) {
      this.$router.push({
        path: '/ShopList/ShopManagement/shop-list',
        query: {
          brandId: item.id
        }
      })
    },
    // 启动状态
    async modifyBrand (rowInfo) {
      try {
        /**
         @desc 总店管理员才能有权限更改编辑
         @return merchantRole 10001 总店管理员 10002 总店店长 10003 总店店员 10004 分店管理员 10005 分店店长  10006分店店员  10007 加盟管理员   10101小兵角色
        */
        if (this.userInfo.merchantRole !== 10001) return this.$message.warning('暂无权限修改')
        const params = { ...rowInfo }
        params.brandStatus = params.status ? 1 : 0
        const res = await modifyBrand(params)
        if (res.error_code === '0') {
          this.$message.success('状态已更新')
          this.getBrandList()
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    },
    showDialog (type, rowInfo) {
      /**
        @desc 总店管理员才能有权限更改编辑
        @return merchantRole 10001 总店管理员 10002 总店店长 10003 总店店员 10004 分店管理员 10005 分店店长  10006分店店员  10007 加盟管理员   10101小兵角色
      */
      if (this.userInfo.merchantRole !== 10001) return this.$message.warning(`暂无权限${type === 2 ? '修改' : '新增'}`)
      this.addShow = true
      this.type = type
      if (Number(this.type) === 2) {
        this.rowInfo = rowInfo
      }
    },
    async getBrandList () {
      try {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const res = await getBrandList()
        if (res.error_code === '0') {
          this.list = res.data.list
          this.list.forEach(item => {
            item.status = item.brandStatus === 1
          })
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.close()
      }
    },
    // 删除品牌
    async deleteBrand (item) {
      try {
        /**
         @desc 总店管理员才能有权限更改编辑
         @return merchantRole 10001 总店管理员 10002 总店店长 10003 总店店员 10004 分店管理员 10005 分店店长  10006分店店员  10007 加盟管理员   10101小兵角色
        */
        if (this.userInfo.merchantRole !== 10001) return this.$message.warning('暂无权限修改')
        await this.$confirm('确认删除此品牌？')
        const res = await deleteBrand({ id: item.id })
        if (res.error_code === '0') {
          this.getBrandList()
          this.$message.success('删除成功')
        } else {
          this.$message.warning(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.block-brand-management-wrap{
  background:#fff;
  margin:0 20px 20px 20px;
  padding:20px;
}
.block-brand-header{
  width:100%;
  height:40px;
  align-items:center;
  .block-btn{
    margin:0 0 0 20px;
  }
}
.block-main{
  margin:20px 0 0 0;
}
.block-list{
  flex-flow:wrap;
  .block-item{
    border:1px solid #e1e1e1;
    padding:10px;
    position:relative;
    width:360px;
    margin:0 20px 0  0;
    .el-icon-delete{
      position: absolute;
      right:10px;
      top:10px;
      font-size:20px;
      cursor: pointer;
    }
    .block-top{
      height:120px;
      align-items:center;
      .block-title{
        font-size:18px;
        color:#409EFF;
        padding:0 0 20px 0;
      }
    }
    .logo{
      width:120px;
      height:120px;
    }
  }
  .block-desc{
    padding:10px 0;
    border-bottom:1px solid #e1e1e1;
    word-wrap:break-word;
    word-break:break-all;
  }
}
.block-right{
  margin:0 0 0 10px;
}
.block-bottom{
  margin:10px 0 0 0;
  height:40px;
  justify-content:space-between;
  align-items:center;
}
.block-btn{
  height:32px;
  line-height:0px;
}
.block-swtich{
  height:32px;
}
</style>
